import React, { Component } from 'react';
import AuthFooter from '../../components/Auth/AuthFooter';
import AuthHeader from '../../components/Auth/AuthHeader';
import LoginRegisterTab from '../../components/Auth/LoginRegisterTab';
import './login-register.css';
import Helper from '../../inc/Helper';
import Settings from '../../inc/Settings';
import LoginForm from '../../components/Auth/Login/LoginForm';
import AuthCheck from '../../components/Auth/AuthCheck';
import SimpleLoading from '../../components/Loading/SimpleLoading';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Api from '../../inc/Api';

class Login extends Component {
    constructor() {
        super();
        this.getUserTokenFromURL();
        this.state = {
            is_admin: false,
            loading: false
        };
    }

    checkAdminRole = () => {
        let api = Api;
        api.setUserToken()
        return new Promise((resolve, reject) => {
          let subdomainLocal = localStorage.getItem('subdomain')
          resolve(
            api.axios().get(Settings.loginUrl + '/user_details').then((res) => {
              if (res.data.Status === "Success") {
                let aditionalData = res.data.data; 
                this.setState({ is_admin: aditionalData?.admin_user });
                if(!("71" in aditionalData.roles) && !("79" in aditionalData.roles)) {
                    window.location.href = `https://${subdomainLocal ? subdomainLocal : 'www'}.lynkaz.com/`;
                } else {
                    Helper.setCookie("roles", JSON.stringify(aditionalData.roles),Settings.userTokenExpireDate);
                    Helper.setCookie("isadmin", aditionalData.admin_user ,Settings.userTokenExpireDate);
                    return <Navigate to={!aditionalData?.admin_user ? '/workflow' : '/template'} />
                }
              }
            })).catch((error) => reject(
                window.location.href = `https://${subdomainLocal ? subdomainLocal : 'www'}.lynkaz.com/`
            ))
        })
    }

    getUserTokenFromURL() {
        this.setState({ loading: true });
        const query = new URLSearchParams(window.location.search);
        const userToken = query.get('t');
        const subdomian = query.get('subdomain');
        if (userToken !== null) {
            Helper.setCookie(Settings.userTokenKey, userToken);
            Helper.setCookie(Settings.subdomainKey, subdomian);
            localStorage.setItem('subdomain', subdomian)
            this.checkAdminRole();
            this.setState({ loading: false });
        }
        else {
            const subdomainCookies = Cookies.get('lynkaz_workflow');
            const tokenCookies = Cookies.get('lynkaq_user_token');
            if(subdomainCookies && tokenCookies) {
                // stay
                return <Navigate to='/workflow' />
            }
            else {
                // redirect
                const subdomainLocal = localStorage.getItem('subdomain')
                window.location.href = `https://${subdomainLocal ? subdomainLocal : 'www'}.lynkaz.com/`;
            }
            this.setState({ loading: false });
        }
    }
    render() {
        const { loading, is_admin } = this.state;

        if (loading) {
            return <SimpleLoading />;
        };

        return (
            <>
                <AuthCheck noAccessForLogin={is_admin ? "/template" : "/workflow"} />
                {/* <div className='login_register_page'> */}
                {/* <AuthHeader /> */}
                {/* <LoginRegisterTab tab="login"/> */}
                {/* <LoginForm /> */}
                {/* <AuthFooter /> */}
                {/* </div> */}
            </>
        );
    }
}

export default Login;